export default __webpack_public_path__ + "static/media/1254.3e7cc1db.png";